import { topicsItems } from '@/mocks/homeData';

export default function TopicsSection() {
  return (
    <section id="topics" className="w-full py-16 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-[1400px] mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-3 py-1 text-xs font-medium rounded-full bg-accent-500/15 text-accent-400 border border-accent-500/20 mb-4">
            话题广场
          </span>
          <h2 className="font-heading text-2xl md:text-3xl lg:text-4xl font-bold text-foreground-50">
            热门话题
          </h2>
          <p className="mt-3 text-sm text-foreground-400 max-w-lg mx-auto">
            全网热议话题实时追踪，点击参与讨论
          </p>
        </div>

        <div className="flex flex-wrap justify-center gap-3 md:gap-4">
          {topicsItems.map((item) => (
            <a
              key={item.id}
              href="#media"
              className={`group flex items-center gap-2 px-4 py-2.5 rounded-full border transition-all duration-300 cursor-pointer whitespace-nowrap ${
                item.active
                  ? 'bg-primary-500/15 border-primary-500/30 text-primary-400 hover:bg-primary-500/25'
                  : 'bg-background-50 border-background-200/50 text-foreground-400 hover:text-foreground-200 hover:border-background-300'
              }`}
            >
              <span className="text-sm font-medium">{item.name}</span>
              <span className={`text-xs ${
                item.active ? 'text-primary-400/70' : 'text-foreground-600'
              }`}>
                {item.heat}
              </span>
              {item.active && (
                <span className="w-1.5 h-1.5 rounded-full bg-accent-500" />
              )}
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}